export function logReportInput(url: string, shouldBeLogged: boolean): void {
  if (shouldBeLogged) {
    console.log(`${url}&input=1`);
  }
}
